const PATH_PREFIX = '/procurement/:companyID';

export default [
  {
    name: 'procurement.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  /** Incoming* */
  {
    name: 'procurement.incoming.enquiries',
    path: `${PATH_PREFIX}/incoming/ask_for_quote`,
  },
  {
    name: 'procurement.incoming.enquiry',
    path: `${PATH_PREFIX}/incoming/ask_for_quote/:docID`,
  },
  {
    name: 'procurement.incoming.request_for_quotes',
    path: `${PATH_PREFIX}/incoming/request_for_quote`,
  },
  {
    name: 'procurement.incoming.request_for_quote',
    path: `${PATH_PREFIX}/incoming/request_for_quote/:docID`,
  },
  {
    name: 'procurement.incoming.quotations',
    path: `${PATH_PREFIX}/incoming/quotation`,
  },
  {
    name: 'procurement.incoming.quotation',
    path: `${PATH_PREFIX}/incoming/quotation/:docID`,
  },
  {
    name: 'procurement.incoming.orders',
    path: `${PATH_PREFIX}/incoming/order`,
  },
  {
    name: 'procurement.incoming.order',
    path: `${PATH_PREFIX}/incoming/order/:docID`,
  },
  {
    name: 'procurement.incoming.delivery_notes',
    path: `${PATH_PREFIX}/incoming/delivery_note`,
  },
  {
    name: 'procurement.incoming.delivery_note',
    path: `${PATH_PREFIX}/incoming/delivery_note/:docID`,
  },
  /** Outgoing* */
  {
    name: 'procurement.outgoing.enquiries',
    path: `${PATH_PREFIX}/outgoing/ask_for_quote`,
  },
  {
    name: 'procurement.outgoing.enquiry',
    path: `${PATH_PREFIX}/outgoing/ask_for_quote/:docID`,
  },
  {
    name: 'procurement.outgoing.request_for_quotes',
    path: `${PATH_PREFIX}/outgoing/request_for_quote`,
  },
  {
    name: 'procurement.outgoing.request_for_quote',
    path: `${PATH_PREFIX}/outgoing/request_for_quote/:docID`,
  },
  {
    name: 'procurement.outgoing.quotations',
    path: `${PATH_PREFIX}/outgoing/quotation`,
  },
  {
    name: 'procurement.outgoing.quotation',
    path: `${PATH_PREFIX}/outgoing/quotation/:docID`,
  },
  {
    name: 'procurement.outgoing.orders',
    path: `${PATH_PREFIX}/outgoing/order`,
  },
  {
    name: 'procurement.outgoing.order',
    path: `${PATH_PREFIX}/outgoing/order/:docID`,
  },
  {
    name: 'procurement.outgoing.delivery_notes',
    path: `${PATH_PREFIX}/outgoing/delivery_note`,
  },
  {
    name: 'procurement.outgoing.delivery_note',
    path: `${PATH_PREFIX}/outgoing/delivery_note/:docID`,
  },
];
